export enum FlowTypes {
  Manual = 'MANUAL',
  Authenticated = 'AUTHENTICATED',
}
export enum ApplicationStatus {
  None = 'NONE',
  ApplicationFinished = 'APPLICATION_FINISHED',
  ApplicationUnderReview = 'APPLICATION_UNDER_REVIEW',
  OfferApproved = 'OFFER_APPROVED',
  OfferNotApproved = 'OFFER_NOT_APPROVED',
  OfferSigned = 'OFFER_SIGNED',
}
export enum GlobalErrorType {
  API_FAILURE = 50,
  TOKEN_EXPIRED,
  CUSTOM_ERROR,
}
export enum ClientType {
  RLC = 'RLC',
  NLC = 'NLC',
  Unknown = 'UNKNOWN',
}

export enum ProductType {
  LOAN = 'loan',
  CARD = 'card',
}

export enum LoanType {
  FLEX_LOAN = 'FLEX_LOAN',
}

export enum OTPErrorType {
  SIGNER_ALREADY_SIGNED = 'Signer already signed', // 400
  INVALID_OTP = 'Incorrect OTP', // 401
  EXPIRED_OTP = 'Expired', // 403
  TOO_MANY_REGENERATIONS = 'Too many regenerations', // 403
  UNKNOWN = '',
}

export enum OwnerTypeEnum {
  MoreThan75 = 'OWN_MORE_THAN_75', // Applicant owns more than 75%, including 100%. BO explanation: "Own more than 75%".
  MorePersonsOwn25 = 'MORE_PERSONS_OWN_25', // At least 1 owner owns between 25% and 75%, including 25 and 75. BO explanation: "One or several persons with more than 25%". (they mean 25% or more).
  NonOneOwn25 = 'NON_ONE_OWN_25', // No owner owns 25% or more. BO explanation: "No one owns more than 25%".
}

export enum Auth0ConnectionKey {
  SE_BANKID,
  DK_MITID,
  FI_FTN,
  BE_EMAIL,
  NL_EMAIL,
  NO_BANKID,
  BE_ITSME,
  NL_IDIN,
  DE_EMAIL,
}

// Analytics

// DON'T CHANGE UNLESS DECIDED TOGETHER WITH MARKETING
export enum EAnalyticsEvent {
  OnboardingApplicationFlow = 'onboarding_application_flow',
  OnboardingOfferFlow = 'onboarding_offer_flow',
}

export const TrackTimeSpentOnSteps = [
  'next_button_pressed',
  'submit_button_pressed',
  'back_button_pressed',
  'skip_button_pressed',
  'auth_button_pressed',
  'start_manual_flow_pressed',
  'confirm_button_pressed',
];

export enum StepStatus {
  Started = 'Started',
  Finished = 'Finished',
  Edit = 'Edit',
  Error = 'Error',
  Submitted = 'Submitted',
}

export enum ApplicationAuthType {
  AuthenticatedFlow = 'authenticatedFlow',
  ManualSubmit = 'manualSubmit',
}

export enum BankConnectionResult {
  Success = 'success',
  Error = 'error',
  Cancelled = 'cancelled',
}

// CSS
export enum FlexContentPlacement {
  FlexStart = 'flex-start',
  FlexEnd = 'flex-end',
  Center = 'center',
  SpaceAround = 'space-around',
  SpaceBetween = 'space-between',
}

export enum ApplicationStep {
  Apply = 1,
  Review = 2,
  Offer = 3,
  Payout = 4,
}

export enum LoanPurposes {
  Marketing = 'MARKETING',
  Hiring = 'EMPLOY_PERSONNEL',
  Equipment = 'BUY_EQUIPMENT',
  Expansion = 'EXPANSION',
  RepayOtherLoan = 'REPAY_OTHER_LOAN',
  Inventory = 'INVENTORY',
  Working = 'WORKING_CAPITAL',
  Other = 'OTHER',
}

export enum ECardPurpose {
  Inventory = 'Inventory',
  ToolsAndEquipment = 'ToolsAndEquipment',
  ComputerSoftware = 'ComputerSoftware',
  OfficeExpenses = 'OfficeExpenses',
  SalariesConsultancy = 'SalariesConsultancy',
  Marketing = 'Marketing',
  Travel = 'Traveling',
  MealsAndDrinks = 'MealsAndDrinks',
  OtherPurpose = 'OtherPurpose',
}

export enum CampaignType {
  FirstCommissionFree = 1,
  FirstMonthFree,
  CustomCommissionDiscount,
  AmortizationFreeMonths,
  MonthlyInterestRateDiscount,
}

export enum KlarnaStatus {
  NOT_STARTED = 'NOT_STARTED',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
}

export enum SignerType {
  Signer = 'Signer',
  Guarantor = 'Guarantor',
  Applicant = 'Applicant',
}

export enum KycQuestionnaireQuestionNames {
  handleCashQuestion = 'Do you handle cash within your organization? For example: receiving cash as payment for products/services or paying salaries in cash.',
  handleCashToWhatExtentQuestion = 'To what extent do you handle cash?',
  handleCashQuestionNew = 'Does the company accept cash for transactions involving goods or services, or for paying salaries?',
  handleCashPercentageTurnoverQuestion = "What percentage of the company's turnover is generated from cash-related transactions?",
}

export enum CountryCode {
  SE = 'SE',
  DK = 'DK',
  FI = 'FI',
  BE = 'BE',
  NL = 'NL',
  NO = 'NO',
  DE = 'DE',
}

export enum ApplicationInfoLevel {
  PRE_BASIC = 'PRE_BASIC',
  BASIC = 'BASIC',
  SUPER = 'SUPER',
}
